import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function TenantPrivacyPage() {
  const { slug } = useParams();
  const [tenant, setTenant] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/tenants/slug/${slug}`).then(({ data }) => setTenant(data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="privacy-page">
        <Button variant="ghost" size="sm" asChild>
          <Link to={`/candidati/${slug}`} data-testid="privacy-back-link">
            <ArrowLeft className="h-4 w-4 mr-2" /> Torna alla pagina dell'istituto
          </Link>
        </Button>
        {notFound ? (
          <p className="mt-10 text-center text-slate-600">Istituto non trovato.</p>
        ) : !tenant ? (
          <p className="mt-10 text-center text-slate-500 text-sm">Caricamento...</p>
        ) : (
          <article className="mt-6">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-lg bg-[#E0E7FF] text-[#003366] flex items-center justify-center">
                <ShieldCheck className="h-5 w-5" />
              </div>
              <div>
                <p className="eyebrow">{tenant.name}</p>
                <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Privacy Policy</h1>
              </div>
            </div>
            <div data-testid="privacy-text" className="institutional-card rounded-xl border border-slate-200 bg-white p-6 sm:p-8 text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">
              {tenant.privacy_text}
            </div>
          </article>
        )}
      </div>
    </div>
  );
}
